import React from 'react';
import propTypes from 'prop-types';

export const ChevronLeftIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      className={variant}
      width={sizeInPixel}
      height={sizeInPixel}
      version="1.1"
      id="collecticon-"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      fill={color}
      viewBox="0 0 16 16"
      enableBackground="new 0 0 16 16"
      xmlSpace="preserve"
    >
      <rect
        id="svgGrid"
        y="0"
        fill="none"
        width={sizeInPixel}
        height={sizeInPixel}
        className={variant}
      />
      <polygon points="12.414,14.586 5.828,8 12.414,1.414 11,0 3,8 11,16 " />
    </svg>
  );
};
ChevronLeftIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
ChevronLeftIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
